import styled from "styled-components";
import { border, breakpoint, color, font } from "../../../../theme";

export const DesktopTable = styled.div`
  display: none;

  @media (min-width: ${breakpoint.desktop}) {
    display: block;
  }
`;

export const List = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media (min-width: ${breakpoint.desktop}) {
    display: none;
  }
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  background-color: ${color.white};
  border-radius: 2rem;
  font-family: ${font.family.secondary};
  color: ${color.grey};
  padding: 1.6rem 2rem;
`;

export const ListDate = styled.div`
  font-size: 1.5rem;
  font-weight: 400;
  color: ${color.liteGrey};
`;

export const ListSeller = styled.div`
  display: flex;
  align-items: center;
  margin: 1.2rem 0 1.6rem;
  min-width: 0;
`;

export const ListSellerText = styled.div`
  margin-left: 1.6rem;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
`;

export const SellerName = styled.div`
  font-size: 2.1rem;
  font-weight: 500;
  color: ${color.grey};
  word-break: break-word;
`;

export const SellerTin = styled.div`
  font-size: 1.5rem;
  font-weight: 400;
  color: ${color.liteGrey};
  word-break: break-word;
`;

export const ListFooter = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1.6rem;
`;

export const FooterItem = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;

  &:last-child {
    align-items: flex-end;
    text-align: right;
  }
`;

export const FooterValue = styled.div`
  font-size: 2rem;
  font-weight: 500;
  color: ${color.grey};
`;

export const FooterLabel = styled.div`
  margin-top: 0.2rem;
  font-size: 1.4rem;
  font-weight: 400;
  color: ${color.liteGrey};
`;

export const NoData = styled.div`
  width: 100%;
  background-color: ${color.white};
  height: 10rem;
  border-radius: ${border.radius};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  line-height: 1.4;
  color: ${color.liteGrey};
  font-family: ${font.family.secondary};
`;

export const LoadingContainer = styled.div`
  top: 0;
  background-color: ${color.white};
  opacity: 0.5;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadMore = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 1.6rem 0 0;
`;
